<template>
  <div class="customer-orders-list">
    <basic-table :maxHeight="maxHeight" :table-data="groupsPage" :table-headers="tableHeaders"
      :has-actions="false" :sortChange="sortChange" :paginationChange="paginationChange"
      :actionWidth="actionWidth" :has-row-expand="false" :showPagination="showPagination" :rowClassName="rowClassName"
      :stripe="!rowClassName" :summary="false">
      <template v-slot:footer-ops>
        <el-button type="primary" plain size="mini" @click="refreshPage">
          Refresh
        </el-button>
      </template>
    </basic-table>
  </div>
</template>
<script>
import debounce from 'lodash/debounce'
import isEqual from 'lodash/isEqual'
// mixin
import { pageJumps } from '@/core/mixin/pages'
// components
import BasicTable from '@/components/common/BasicTable.vue'
// models
// msg
import { PalletScanProductsHeaders } from '@/core/models/pallet'
// utils
import {
  Ascending,
  Descending,
  DefaultPageSize,
  PageCurrentKey,
  PageSizeKey
} from '@/core/configs/types'
import { listPalletProducts } from '@/api/pallet'
export default {
  name: 'PalletProductList',
  mixins: [pageJumps],
  props: {
    palletId: {
      type: String,
      default: null
    },
    refresh: {
      type: Boolean,
      default: false
    },
    showActions: {
      type: Boolean,
      default: true
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    showHeaderOps: {
      type: Boolean,
      default: true
    },
    showLabelAction: {
      type: Boolean,
      default: true
    },
    actionWidth: {
      type: Number,
      default: 140
    },
    maxHeight: {
      type: Number,
      default: -1
    },
    rowClassName: {
      type: Function,
      default: () => { }
    },
    excludeCols: {
      type: Array,
      default: () => []
    }
  },
  components: {
    BasicTable
  },
  data() {
    return {
      palletProducts: null,
      loadingData: false,
      pagination: {
        [PageSizeKey]: this.showPagination ? DefaultPageSize : -1,
        [PageCurrentKey]: 1,
        total: 0,
        asc: '',
        desc: ''
      },
      debouncedQuery: debounce(this.fetchProducts, 300)
    }
  },
  computed: {
    groupsPage() {
      return {
        records: this.palletProducts,
        ...this.pagination
      }
    },
    tableHeaders() {
      const toExclude = [...this.excludeCols]
      return PalletScanProductsHeaders.filter(one => !toExclude.includes(one.key))
    }
  },
  methods: {
    paginationChange(key, path, value) {
      this.pagination[key] = value
      this.debouncedQuery()
    },
    sortChange(sort) {
      if (sort.order === Ascending) {
        this.pagination.asc = sort.col
        this.pagination.desc = ''
      } else if (sort.order === Descending) {
        this.pagination.desc = sort.col
        this.pagination.asc = ''
      }
      this.debouncedQuery()
    },
    refreshPage() {
      this.debouncedQuery()
    },
    fetchProducts() {
      listPalletProducts(this.palletId).then(res => {
        this.$set(this, 'palletProducts', res)
      })
    },
    async fetchCustomerOrders() {
    },
    checkExpand(item) {
      return true
    },
    resetMoreCount() {
      this.morePalletForm[2].value = this.morePalletForm[2].default
    }
  },
  watch: {
    refresh: {
      handler() {
        this.debouncedQuery()
      },
      immediate: true
    },
    palletQuery: {
      handler(one, two) {
        if (isEqual(one, two)) return
        this.debouncedQuery()
      },
      deep: true
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/styles/common.scss';

.header-buttons {
  margin-bottom: 10px;
}

.table-customer-orders-col {
  gap: 10px;
  flex-wrap: wrap;
}

.table-pallet-product-detail {
  gap: 10px;
  flex-wrap: wrap;
  padding: 10px 20px;

  .product-item {
    display: flex;
    gap: 20px;
    padding: 10px;
    background-color: #eee;
    border-radius: 6px;

    .quantity {
      font-size: 32px;
    }
  }
}

.actions {
  flex-wrap: wrap;
}
</style>
